import React from "react";
import PropTypes from "prop-types";
import tw, { styled } from "twin.macro";
import { Link } from "gatsby";

const styles = ({ form, blog, sidebar }) => [
  tw`relative flex items-center justify-center px-8 py-4 md:(py-5 px-16) font-gothic uppercase tracking-widest text-center text-white duration-500 ease-in-out bg-dark rounded-full leading-none hover:(bg-primary)`,

  form &&
    tw`bg-primary w-full py-6! border-2 border-primary hover:bg-transparent`,

  form && sidebar && tw`bg-dark hover:bg-primary w-full border-none`,

  blog &&
    tw`text-dark p-0! bg-transparent gap-4 rounded-none before:(duration-500 ease-in-out content[''] w-10 h-0.5 bg-primary) hover:(bg-transparent text-primary before:w-16)`,
];
const A = styled(Link)(styles);
const Btn = styled.button(styles);

const Button = ({ title, children, url, to: _, ...rest }) => {
  const Component = !!url ? A : Btn;
  return (
    <Component to={url} {...rest}>
      {title || children}
    </Component>
  );
};

Button.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
};

export default Button;
